import { useEffect, useState, type FC } from 'react';

import { useDynamicReducer } from '@/domains/core/applicationState/hooks/useDynamicReducer';
import {
  httpQueryClient,
  QueryClientProvider,
} from '@/domains/core/httpClient/queryClient';
import { wishlistReducer } from '@/domains/proB2BServices/Wishlists/store/Wishlists.reducer';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

import { AddToWishlistRender } from './components/main/AddToWishlistRender';
import { STATUS, STEPS } from './constants';

export const AddToWishList: FC = () => {
  const [animate, setAnimate] = useState(false);
  useDynamicReducer('proB2BServices.wishlists', wishlistReducer);
  const detail = useDetail();
  const { productId = 0 } = detail;

  const onClose = (step: STEPS, status: STATUS) => {
    if (step === STEPS.FEEDBACK && status === STATUS.SUCCESS) {
      setAnimate(true);
      setTimeout(() => {
        setAnimate(false);
      }, 1200);
    }
  };

  useEffect(() => {
    if (animate) document.body.classList.add('animateWishlist');
    else document.body.classList.remove('animateWishlist');
  }, [animate]);

  return (
    <QueryClientProvider client={httpQueryClient}>
      <AddToWishlistRender productId={productId} onClose={onClose} />
    </QueryClientProvider>
  );
};
